import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import styles from "./Dashboard.module.css";

import SidebarMenu from "./SidebarMenu";
import StatusPanel from "./StatusPanel";
import CardsPanel from "./CardsPanel";

export default function Dashboard() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedCard, setSelectedCard] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const userId = auth.currentUser.uid;

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const docRef = doc(db, "users", userId);

    // 🔥 REAL‑TIME LISTENER
    const unsubscribe = onSnapshot(docRef, (snap) => {
      if (snap.exists()) {
        setUserData(snap.data());
      } else {
        // Default structure if user doc doesn't exist
        setUserData({
          assets: {},
          liabilities: {},
          infoDocs: { messages: [], documents: [] },
          maintenance: {},
          trustedContacts: [],
          inactivitySettings: { inactivityPeriodMonths: 0, reminderDays: 0 }
        });
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userId]);

  if (loading) return <p>Loading dashboard...</p>;

  const handleSignOut = async () => {
    await auth.signOut();
    navigate("/login");
  };

  const formatName = (name) =>
    name
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  return (
    <div className={styles.dashboardContainer}>
      {/* HEADER */}
      <div className={styles.dashboardHeader}>
        <button className={styles.burgerMenu} onClick={toggleMenu}>☰</button>

        <h1 className={styles.title}>
          Hello {userData?.name ? ` ${formatName(userData.name)}` : ""}
        </h1>

        <button className={styles.btnSignout} onClick={handleSignOut}>
          Sign Out
        </button>
      </div>

      {/* HAMBURGER SIDEBAR */}
      <SidebarMenu
        menuOpen={menuOpen}
        toggleMenu={toggleMenu}
        navigate={navigate}
        handleSignOut={handleSignOut}
      />

      {/* MAIN CONTENT */}
      <div className={styles.mainContent}>
        <StatusPanel userData={userData} />
        <CardsPanel
          userData={userData}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
          navigate={navigate}
        />
      </div>
    </div>
  );
}
